export const defaultHover = {
  add: null,
  inputAdd: null,
  inputEddit: null,
  cancel: null,
  delete: null
}

export const defaultAnchor = {
  open: null,
  add: null,
  edit: null,
  delete: null,
  question: null
}

export const defaultTag = {
  tagName: null,
  tagId: null,
  isShow: true,
};